<div class="breadcrumb">
    <div class="breadcrumb-root" (click)="rootBreadcrumbOnClicked()">{{currentCloud}}&nbsp;</div>

    @if (loadingHistory | async) {
        <div class="breadcrumb-loader">
            <span> > </span>
            <i class="fas fa-spinner fa-spin"></i>
        </div>
    }
    
    @if (menuBreadcrumbs.length) {
        <div #bcMenu class="breadcrumb-menu-btn"
            (click)="menuOffset = $event.currentTarget.offsetLeft; showBreadcrumbsMenu = !showBreadcrumbsMenu;">
            >&nbsp;...&nbsp;</div>
    }

    @for (breadcrumb of topBreadcrumbs; track breadcrumb.url) {
        <div class="breadcrumb-item"
            (click)="breadcrumbOnClicked(breadcrumb.url)">
            >&nbsp;{{breadcrumb.label}}&nbsp;
        </div>
    }
</div>

@if (showBreadcrumbsMenu) {
    <div class="breadcrumb-menu" [ngStyle]="{'left': menuOffset + 'px'}"
        (mouseleave)="showBreadcrumbsMenu = !showBreadcrumbsMenu">

        @for (breadcrumb of menuBreadcrumbs; track $index) {
            <li class="breadcrumb-menu-item"
                (click)="breadcrumbOnClicked(breadcrumb.url)">{{breadcrumb.label}}
            </li>
        }
    </div>
}
